/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProfileTag = {
    Carrier: 'CARRIER',
    Customer: 'CUSTOMER',
    Empty: 'EMPTY'
} as const;
export type ProfileTag = typeof ProfileTag[keyof typeof ProfileTag];

